module.exports = __webpack_public_path__ + "img/flag.35a07239.svg";